import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from 'react-redux';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { TextField, Button, Radio, RadioGroup, FormControlLabel, Typography, Dialog,DialogContent, FormControl, FormLabel, Box, IconButton, DialogTitle } from "@mui/material";
import { useraccountVerification } from '../../pages/Dashboard/onboardingSlice';

const BusinessVerification = ({VerificationFormStatus,onClose}) => {
  const dispatch = useDispatch();
  const profile = useSelector(state => state.profile);
  const verification = useSelector(
      (state) => state.onboarding && state.onboarding.verification
    );
  console.log(VerificationFormStatus)
  console.log(verification)
  const [formData, setFormData] = useState({
    businessName: "",
    businessNumber: "",
    fullName: "",
    businessTitle: "",
    address: "",
    ownership: "owner",
    otherOwnership: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    // Remove error when user types
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.businessName.trim()) newErrors.businessName = "Required";
    if (!formData.businessNumber.trim()) newErrors.businessNumber = "Required";
    if (!formData.fullName.trim()) newErrors.fullName = "Required";
    if (!formData.businessTitle.trim()) newErrors.businessTitle = "Required";
    if (!formData.address.trim()) newErrors.address = "Required";
    
    // Validate "Other" field only if selected
    if (formData.ownership === "other" && !formData.otherOwnership.trim()) {
      newErrors.otherOwnership = "Required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      console.log("Form Submitted:", formData);
      dispatch(useraccountVerification(profile.profile.id,formData))
    }
  };

  const businessFormClose = () => {
    setFormData({
      ...formData,
      businessName: "",
      businessNumber: "",
      fullName: "",
      businessTitle: "",
      address: "",
      ownership: "owner",
      otherOwnership: "",
    })
    setErrors({})
    onClose("")
  };

  useEffect(() => {
    if (verification && verification.notification && verification.notification.messageContent && verification.notification.messageContent[0]==='We are verifying your business information. It will take upto 24 hours. You will get an email once activated.') {
      setFormData({})
      onClose("filled")
    }
  }, [verification]);
  

  return (
    <Dialog
      keepMounted
      open={
        VerificationFormStatus
      }
      // onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ "& .MuiDialog-paper": { maxWidth: "800px" } }}
    >

      <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 24px 0px 35px', marginTop: '20px' }}>
          <h6 style={{ textAlign: 'center', fontSize: '20px', margin: '10px 0', padding: '0' }}>Business Information</h6>
          <IconButton onClick={businessFormClose}>
            <CloseOutlinedIcon onClick={businessFormClose} />
          </IconButton>
      </DialogTitle>
      <DialogContent>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Legal Business Name*"
          name="businessName"
          value={formData.businessName}
          onChange={handleChange}
          // onBlur={handleBlur}
          fullWidth
          margin="normal"
          error={!!errors.businessName}
          helperText={errors.businessName}
        />

        <TextField
          label="Business Number*"
          name="businessNumber"
          value={formData.businessNumber}
          onChange={handleChange}
          // onBlur={handleBlur}
          fullWidth
          margin="normal"
          error={!!errors.businessNumber}
          helperText={errors.businessNumber}
        />

        <TextField
          label="Your Full Name*"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          // onBlur={handleBlur}
          fullWidth
          margin="normal"
          error={!!errors.fullName}
          helperText={errors.fullName}
        />

        <TextField
          label="Your Business Title*"
          name="businessTitle"
          value={formData.businessTitle}
          onChange={handleChange}
          // onBlur={handleBlur}
          fullWidth
          margin="normal"
          error={!!errors.businessTitle}
          helperText={errors.businessTitle}
        />

        <TextField
          label="Registered Address:* (including postal code)"
          name="address"
          value={formData.address}
          onChange={handleChange}
          // onBlur={handleBlur}
          fullWidth
          margin="normal"
          multiline
          rows={3}
          error={!!errors.address}
          helperText={errors.address}
        />

        <FormControl margin="normal">
          <FormLabel>Are you the?*</FormLabel>
          <RadioGroup row name="ownership" value={formData.ownership} onChange={handleChange}>
            <FormControlLabel value="owner" control={<Radio color="secondary" />} label="Owner" />
            <FormControlLabel value="partner" control={<Radio color="secondary" />} label="Partner" />
            <FormControlLabel value="other" control={<Radio color="secondary" />} label="Other" />
          </RadioGroup>
        </FormControl>

         {/* Show text field if "Other" is selected */}
         {formData.ownership === "other" && (
          <TextField
            label="Please specify*"
            name="otherOwnership"
            value={formData.otherOwnership}
            onChange={handleChange}
            // onBlur={handleBlur}
            fullWidth
            margin="normal"
            error={!!errors.otherOwnership}
            helperText={errors.otherOwnership}
          />
        )}

        <Box mt={3}>
          <Button type="submit" fullWidth variant="contained" sx={{ backgroundColor: "#2B2B2B", color: "#FFFFFF", padding: "10px", "&:hover": { backgroundColor: "#3A3A3A" } }}>
            Verify my account
          </Button>
        </Box>

        <Typography variant="body2" color="textSecondary" mt={2} textAlign="center">
          By clicking the button above, you consent to ShippingChimp.com verifying your business details to ensure your shipping account is securely set up.
        </Typography>
      </form>
      </DialogContent>
    </Dialog>
  );
};

export default BusinessVerification;
